import { convertTextWithCitations } from 'modules/shared/libs/chat/utils/sources.utils';

import type {
  ChatUIMessage,
  CitationSource,
} from 'modules/shared/libs/chat/types';

export type AnswerFollowupAction = {
  action: string;
  followup_data: Record<string, unknown>;
};

export type AnswerApiMessage = {
  id: string;
  thread_id: string;
  message: {
    id: string;
    role: 'user' | 'assistant';
    content: string;
    name: string | null;
  };
  citation_sources: CitationSource[];
  followups: AnswerFollowupAction[];
};

export function convertAnswerApiMessagesToUIMessages(
  messages: AnswerApiMessage[],
): ChatUIMessage[] {
  return messages.map((msg) => {
    // Use the inner AG-UI message id (msg.message.id) to match the id assigned
    // during streaming (TEXT_MESSAGE_START / user message via createUserMessage).
    // Card-schedule lookups (useCardScheduleByAnswerId) key off this id, so it
    // must remain stable across streaming and history-loaded views.
    const baseMessage = {
      id: msg.message.id,
      createdAt: new Date(),
    };

    if (msg.message.role === 'user') {
      return {
        ...baseMessage,
        role: 'user' as const,
        parts: [
          { type: 'text' as const, text: msg.message.content, state: 'done' },
        ],
      };
    }

    const parts: ChatUIMessage['parts'] = [
      {
        type: 'text' as const,
        text: convertTextWithCitations(msg.message.content),
        state: 'done',
      },
    ];

    if (msg.citation_sources && msg.citation_sources.length > 0) {
      parts.push({
        type: 'data-citation_sources',
        data: msg.citation_sources,
      });
    }

    if (msg.followups && msg.followups.length > 0) {
      parts.push({
        type: 'data-followups' as const,
        data: msg.followups,
      });
    }

    return {
      ...baseMessage,
      role: 'assistant' as const,
      parts,
    };
  });
}
